import AclName from '../../../acl/AclName';
import { KSEF_ROUTES } from '../constants/routes';

export const ksefRoutes = [
  {
    path: KSEF_ROUTES.INVOICES_SALE.path,
    name: KSEF_ROUTES.INVOICES_SALE.name,
    components: {
      default: () => import('../purchases/views/KsefSaleView.vue'),
      topRightSection: () => import('../purchases/components/KsefPurchaseTopRightSection.vue'),
    },
    meta: {
      acl: AclName.CanViewKsefPurchaseInvoicesList,
      pageTitle: 'KSeF - sprzedaż',
      stickyAccountTabs: true,
      breadcrumb: [
        { title: 'Moje pliki', url: '/files' },
        { title: 'KSeF - sprzedaż', url: KSEF_ROUTES.INVOICES_SALE.path },
      ],
    },
  },
  {
    path: KSEF_ROUTES.INVOICES_PURCHASE.path,
    name: KSEF_ROUTES.INVOICES_PURCHASE.name,
    components: {
      default: () => import('../purchases/views/KsefPurchasesView.vue'),
      topRightSection: () => import('../purchases/components/KsefPurchaseTopRightSection.vue'),
    },
    meta: {
      acl: AclName.CanViewKsefPurchaseInvoicesList,
      pageTitle: 'KSeF - zakup',
      stickyAccountTabs: true,
      breadcrumb: [
        { title: 'Moje pliki', url: '/files' },
        { title: 'KSeF - zakup', url: KSEF_ROUTES.INVOICES_PURCHASE.path },
      ],
    },
  },
  {
    path: KSEF_ROUTES.INVOICES_PURCHASE_AUDIT_LOG.path,
    name: KSEF_ROUTES.INVOICES_PURCHASE_AUDIT_LOG.name,
    components: {
      default: () => import('../purchases/views/KsefPurchaseInvoiceHistoryView.vue'),
    },
    meta: {
      acl: AclName.CanViewKsefPurchaseInvoicesList,
      breadcrumb: [
        { title: 'Moje pliki', url: '/files' },
        { title: 'KSeF - zakup', url: KSEF_ROUTES.INVOICES_PURCHASE.path },
        { title: 'Dziennik zmian', url: '' },
      ],
    },
  },
  {
    path: KSEF_ROUTES.INVOICES_SALE_AUDIT_LOG.path,
    name: KSEF_ROUTES.INVOICES_SALE_AUDIT_LOG.name,
    components: {
      default: () => import('../purchases/views/KsefPurchaseInvoiceHistoryView.vue'),
    },
    props: {
      default: {
        backRouteName: KSEF_ROUTES.INVOICES_SALE.name,
      },
    },
    meta: {
      acl: AclName.CanViewKsefPurchaseInvoicesList,
      pageTitle: 'Dziennik zmian',
      breadcrumb: [
        { title: 'Moje pliki', url: '/files' },
        { title: 'KSeF - sprzedaż', url: KSEF_ROUTES.INVOICES_SALE.path },
        { title: 'Dziennik zmian', url: '' },
      ],
    },
  },
  {
    path: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE_AUDIT_LOG.path,
    name: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE_AUDIT_LOG.name,
    components: {
      default: () => import('../purchases/views/KsefPurchaseInvoiceHistoryView.vue'),
    },
    props: {
      default: {
        backRouteName: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE.name,
      },
    },
    meta: {
      acl: AclName.CanViewKsefPurchaseInvoicesList,
      pageTitle: 'Dziennik zmian',
      breadcrumb: [
        { title: 'Archiwum', url: '' },
        { title: 'KSeF Faktury', url: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE.path },
        { title: 'Dziennik zmian', url: '' },
      ],
    },
  },
  {
    path: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE.path,
    name: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE.name,
    components: {
      default: () => import('../archived-purchases/views/ArchivedKsefPurchasesView.vue'),
      topRightSection: () => import('../purchases/components/KsefPurchaseTopRightSection.vue'),
    },
    meta: {
      acl: AclName.CanViewKsefPurchaseInvoicesList,
      breadcrumb: [
        { title: 'Archiwum', url: '' },
        { title: 'KSeF Faktury', url: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE.path },
      ],
    },
  },
];
